export default __webpack_public_path__ + "static/favicon-ab64c683044bddc37f799882955b0b91.ico";